import React, { useState } from 'react';
import Unit from './Modular/Unit';
import './ContactForm.css'; // Assuming you have a CSS file for styling

interface FormData {
  name: string;
  email: string;
  message: string;
}

interface Status {
  loading: boolean;
  ok: boolean | null;
  msg: string;
}

const ContactForm = () => {
  const [form, setForm] = useState<FormData>({
    name: '',
    email: '',
    message: '',
  });
  const [status, setStatus] = useState<Status>({
    loading: false,
    ok: null,
    msg: '',
  });

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus({ loading: true, ok: null, msg: '' });

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        const { error } = await response.json();
        throw new Error(error || 'Failed to send message');
      }

      setStatus({
        loading: false,
        ok: true,
        msg: 'Message sent successfully!',
      });
      setForm({ name: '', email: '', message: '' }); // reset form on success
    } catch (error) {
      setStatus({ loading: false, ok: false, msg: 'Error sending message' });
      console.error('Error:', error);
      return;
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit} noValidate>
      <div>
        <label>Name:</label>
        <input
          id="name"
          name="name"
          type="text"
          value={form.name}
          onChange={onChange}
          required
        />
      </div>

      <div>
        <label>Email:</label>
        <input
          type="text"
          name="email"
          value={form.email}
          onChange={onChange}
        />
      </div>

      <div>
        <label>Message:</label>
        <textarea
          name="message"
          value={form.message}
          onChange={onChange}
          required
        />
      </div>

      <button type="submit" className="">
        Send Email
      </button>

      {status.msg && (
        <p className={status.ok ? 'status success' : 'status error'}>
          {status.msg}
        </p>
      )}
    </form>
  );
};

export default ContactForm;
